import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import styled from 'styled-components';
import {serviceURL, canvasUrlParams, riskCategory} from '../../../../util/uiconstants';
import env from '../../../../util/env';
import {isNullOrUndefined} from '../../../../util/utils';
import {useEngagementId} from '../../../../util/customHooks';
import {useAresUrlParameters, useSelectedStEntityId} from '../../../../util/Ares/customHooks';
import {getTaskDocumentByDocumentId} from '../../../../selectors/Ares/selectors';
import * as RiskTypeAction from '../../../../actions/RiskType/risktypeactions';
import {RiskFactorsValidExpands, getRiskFactors} from '../../../../actions/RiskFactor/riskfactoractions';
import * as AccountAction from '../../../../actions/Account/accountactions';
import Loader from '../../LoadingIndicator/LoadingIndicator';
import {useOverrideLabels} from '../../../Main/Forms/Utilities/OverrideLabelsProvider';
import RiskTypeListItem from './RiskTypeListItem';
import RiskTypeNotARomm from '../RelateRiskToAccounts/Risks/RiskTypeNotARomm';
import RiskFactorUnassociatedLabel from './Risks/RiskFactorUnassociatedLabel';

export default function RiskTypeList(props) {
	const {
		headerId,
		sectionId,
		getBodiesBySectionId,
		isDisplayAccounts,
		isDisplayRiskFactors,
		isDisabled
	} = props;

	const dispatch = useDispatch();
	const riskTypes = useSelector((state) => state.riskTypes);
	const risks = useSelector((state) => state.risks);
	const engagementId = useEngagementId();
	const {documentId} = useAresUrlParameters();
	const document = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const [isLoading, setIsLoading] = useState(true);

	const [selectedStEntityId] = useSelectedStEntityId();

	const {labels} = useOverrideLabels();

	useEffect(() => {
		let commonUrlParams = `&${canvasUrlParams.riskCategory}=${riskCategory.risks}`;
		if (isDisplayAccounts) {
			const queryParameters = 'risks,risks.assertions,risks.assertions.account,risks.riskfactors';
			dispatch(
				RiskTypeAction.getRiskTypes_old(
					env.getBaseURL(serviceURL, Number(engagementId)) + 'RiskTypes?isActive=true&expand=' + queryParameters + commonUrlParams
				)
			).finally(() => {
				setIsLoading(false);
			});
		} else {
			Promise.all([
				dispatch(
					RiskTypeAction.getRiskTypes_old(
						env.getBaseURL(serviceURL, Number(engagementId)) + 'RiskTypes?isActive=true&expand=risks,risks.riskfactors' + commonUrlParams
					)
				),
				dispatch(
					getRiskFactors(engagementId, {
						expand: RiskFactorsValidExpands.formHeaders,
						filterMultiEntityIds: selectedStEntityId
							? selectedStEntityId
							: !isNullOrUndefined(document?.stEntityId)
							? document.stEntityId
							: undefined
					})
				)
			]).finally(() => {
				setIsLoading(false);
			});
		}
	}, [risks, selectedStEntityId]);

	useEffect(() => {
		if (isDisplayAccounts && riskTypes.update === undefined && riskTypes !== undefined) {
			dispatch(AccountAction.getAccounts(engagementId, {includeAssertions: true, includePspIndexes: true})).then(
				dispatch(
					getRiskFactors(engagementId, {
						expand: RiskFactorsValidExpands.formHeaders,
						filterMultiEntityIds: selectedStEntityId
							? selectedStEntityId
							: document?.stEntityId
							? document.stEntityId
							: undefined
					})
				)
			);
		}
	}, [riskTypes, selectedStEntityId]);

	return (
		<>
			<StyledRiskTypeList className="StyledRiskTypeList">
				{isDisplayAccounts === false ? (
					<>
						<span className="teamevent-title">{labels.identifiedRiskFactors} </span>
						<RiskFactorUnassociatedLabel headerId={headerId} sectionId={sectionId} />
					</>
				) : null}
				{isLoading ? (
					<Loader view="inlineView" show={isLoading} />
				) : riskTypes?.data?.length > 0 ? (
					riskTypes.data.map((riskType) => (
						<RiskTypeListItem
							riskTypeId={riskType.id}
							key={riskType.id}
							risksList={riskType.risks}
							isDisplayAccounts={isDisplayAccounts}
							getBodiesBySectionId={getBodiesBySectionId}
							isDisabled={isDisabled}
						/>
					))
				) : (
					<section className="empty-template">
						<span className="no-risks">{labels.noRiskFactors}</span>
					</section>
				)}
				{isDisplayAccounts === false || isDisplayRiskFactors === true ? <RiskTypeNotARomm /> : null}
			</StyledRiskTypeList>
		</>
	);
}

const StyledRiskTypeList = styled.section`
	margin: var(--px-20) 0 var(--px-10) !important;
	.empty-template {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: default;
		border: 0;
		.no-risks {
			color: var(--neutrals-700);
			font-size: var(--px-16);
			padding: var(--px-20) 0;
		}
	}
	.teamevent-title {
		display: block;
		font-size: var(--px-20);
		font-weight: 300;
		margin-bottom: var(--px-30);
	}
	.StyledRiskFactorUnassociatedLabel {
		padding-bottom: var(--px-20);
	}
	&.StyledRiskTypeList {
		.notrom-risklist {
			&:last-child {
				margin-bottom: 0;
			}
			.motif-accordion-content {
				.StyledRiskFactorsList {
					padding: var(--px-8) 0 var(--px-8) var(--px-20);
					.StyledRiskFactorsListItem {
						padding: 0;
						margin: 0;
						& + .StyledRiskFactorsListItem {
							margin-top: var(--px-16);
						}
					}
				}
			}
			.riskfactor-description {
				color: var(--neutrals-700);
				font-weight: 400;
				font-size: var(--px-14);
				line-height: var(--px-20);
				padding: 0;
				margin-bottom: var(--px-8);
			}
			.riskfactor-rationale-header {
				font-weight: 400;
				color: var(--neutrals-700);
			}
			.riskfactor-rationale {
				line-height: var(--px-20);
				font-weight: 300;
				color: var(--neutrals-700);
			}
			.empty-template {
				border: none;
				.no-identifiedrisks {
					font-weight: 300;
					font-size: var(--px-14);
					line-height: var(--px-20);
					color: var(--neutrals-700);
				}
			}
		}
	}
`;
